/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Text, View } from "@aws-amplify/ui-react";
export default function TextTuchikakunin(props) {
  const { overrides, ...rest } = props;
  return (
    <View
      width="288px"
      height="18px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      position="relative"
      padding="0px 0px 0px 0px"
      {...rest}
      {...getOverrideProps(overrides, "TextTuchikakunin")}
    >
      <Text
        fontFamily=""
        fontSize="14px"
        fontWeight=""
        color="rgba(255,255,255,1)"
        lineHeight="21px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        width="288px"
        height="unset"
        gap="unset"
        alignItems="unset"
        position="absolute"
        top="0%"
        bottom="-16.67%"
        left="0%"
        right="0%"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="こちらの内容がみなさんに通知されます。"
        {...getOverrideProps(
          overrides,
          "\u3053\u3061\u3089\u306E\u5185\u5BB9\u304C\u307F\u306A\u3055\u3093\u306B\u901A\u77E5\u3055\u308C\u307E\u3059\u3002"
        )}
      ></Text>
    </View>
  );
}
